var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14110",
    "data-name": "Group 14110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5482",
    "data-name": "Rectangle 5482",
    width: 15,
    height: 15,
    fill: "#7dab3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14111",
    "data-name": "Group 14111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9601",
    "data-name": "Group 9601",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29909",
    "data-name": "Path 29909",
    d: "M278.037,107.248c-.039.285-.07.571-.119.853a7.363,7.363,0,0,1-.724,2.137,16.291,16.291,0,0,0-3.44-1.089,11.586,11.586,0,0,0,0-4.736,16.267,16.267,0,0,0,3.435-1.094c.025.046.05.086.071.128a7.479,7.479,0,0,1,.75,2.735,1.049,1.049,0,0,0,.026.128Z",
    transform: "translate(-263.037 -99.272)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29910",
    "data-name": "Path 29910",
    d: "M208.888,0c.316.059.635.1.946.178A7.431,7.431,0,0,1,214.2,3.13c.019.027.035.056.062.1a14.807,14.807,0,0,1-3.175.987c-.049-.144-.1-.282-.142-.419a11.347,11.347,0,0,0-2.1-3.678.978.978,0,0,1-.075-.12Z",
    transform: "translate(-200.598)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29911",
    "data-name": "Path 29911",
    d: "M39.712,0a.614.614,0,0,1-.057.1,11.4,11.4,0,0,0-2.222,4c-.011.036-.027.071-.042.113a15.057,15.057,0,0,1-3.164-.983.7.7,0,0,1,.047-.09A7.436,7.436,0,0,1,39.28.055c.105-.017.21-.037.315-.055Z",
    transform: "translate(-32.887)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29912",
    "data-name": "Path 29912",
    d: "M.849,103.361a16.208,16.208,0,0,0,3.429,1.091,11.576,11.576,0,0,0,0,4.738,16.106,16.106,0,0,0-3.428,1.086,7.449,7.449,0,0,1,0-6.915",
    transform: "translate(0 -99.312)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29913",
    "data-name": "Path 29913",
    d: "M131.828,134.836a10.532,10.532,0,0,1,0,4.451,16.917,16.917,0,0,0-4.574,0,10.519,10.519,0,0,1,0-4.452,14.763,14.763,0,0,0,4.577,0",
    transform: "translate(-122.041 -129.554)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29914",
    "data-name": "Path 29914",
    d: "M209.006,279.8a13.183,13.183,0,0,0,1.369-1.988,11.516,11.516,0,0,0,.935-2.214,14.869,14.869,0,0,1,3.19.993,7.469,7.469,0,0,1-5.494,3.209",
    transform: "translate(-200.824 -264.801)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29915",
    "data-name": "Path 29915",
    d: "M33.7,276.626a14.986,14.986,0,0,1,3.191-.993,11.746,11.746,0,0,0,2.307,4.2,7.49,7.49,0,0,1-5.5-3.209",
    transform: "translate(-32.385 -264.835)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29916",
    "data-name": "Path 29916",
    d: "M143.383,21.27a15.807,15.807,0,0,1-4.091,0,10.426,10.426,0,0,1,2.045-3.674,10.443,10.443,0,0,1,2.046,3.675",
    transform: "translate(-133.839 -16.906)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29917",
    "data-name": "Path 29917",
    d: "M139.29,268.607a15.756,15.756,0,0,1,4.09,0,10.419,10.419,0,0,1-2.045,3.675,10.426,10.426,0,0,1-2.045-3.673",
    transform: "translate(-133.837 -257.955)",
    fill: "#7dab3c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg5);
export default __webpack_public_path__ + "static/media/svg5.5aae49fb2f54299aceb9920900b78b80.svg";
export { ForwardRef as ReactComponent };